export const DEFAULT_FRANCHISE_ID = "-OJaR0VMGwgnsgRDIPBQ";
